import { parentFind } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"

export function getTreeIdFromItem(item) {
    return parentFind(item, (c) => c[PlanRoot])?.id
}

export function getTreeItemFromItem(item) {
    return parentFind(item, (c) => c[PlanRoot])
}
